import React from "react";
import { connect } from "react-redux";
import { PremiumAction } from "../../actions";
import { withRouter } from "react-router-dom";
import { FormContainer, PurchaseContainer } from "./style";
import { Header } from "./components/header";
import { Steps } from "./components/steps";
import ChoosePlan from "./components/forms/choosePlan";
import ConfirmPlan from "./components/forms/confirmPlan";
import {
  PURCHASE_MODE_NAMES,
  PURCHASE_STEPS_TYPE,
  PURCHASE_USED_KEY
} from "../../constants/purchase";
import { extractItemFromLinkState } from "../../lib/extractItemFromObject";

const Index = props => {
  const {
    loading,
    error,
    data,
    calculatePriceLoading,
    buyGiftLoading,
    user,
    history
  } = props;
  const extractFromLinkState = key => {
    return extractItemFromLinkState(history, key);
  };

  const findAppropriateTypeForSend = () => {
    return extractFromLinkState(PURCHASE_USED_KEY.PURCHASE_ACTION);
  };
  const findOwnerId = () => {
    return extractFromLinkState(PURCHASE_USED_KEY.OWNER_ID);
  };
  const findAppliedLimits = () => {
    return extractFromLinkState(PURCHASE_USED_KEY.APPLIED_LIMITS);
  };
  const getWalletAmount = () => {
    return user && user.wallet;
  };

  const fetchNecessaryRequest = step => {
    const formStep = extractFromLinkState(PURCHASE_USED_KEY.FORM_STEP);
    const owner_id = findOwnerId();
    const applied_limits = findAppliedLimits();
    if (step === PURCHASE_STEPS_TYPE.CHOOSE_PLAN || !step) {
      if (formStep === PURCHASE_STEPS_TYPE.CHOOSE_PLAN) {
        let type = findAppropriateTypeForSend(formStep);
        props.getPremiumInit({ type, owner_id, applied_limits });
      }
    }
    if (step === PURCHASE_STEPS_TYPE.CONFIRM_PLAN || !step) {
      if (formStep === PURCHASE_STEPS_TYPE.CONFIRM_PLAN) {
        const data = {
          plan_id: extractFromLinkState(PURCHASE_USED_KEY.PLAN_ID),
          type: findAppropriateTypeForSend(),
          duration_id: extractFromLinkState(PURCHASE_USED_KEY.DURATION_ID),
          owner_id: owner_id
        };
        props.calculatePrice(data);
      }
    }
  };

  const calculatePrice = (
    formData,
    transition,
    buyGift,
    callWalletFunc,
    callPromoCodeFunc
  ) => {
    const data = {
      type: findAppropriateTypeForSend(),
      owner_id: findOwnerId(),
      promo_code: "",
      use_wallet: false,
      ...formData
    };
    if (callWalletFunc) {
      props.useWallet(data);
    } else if (callPromoCodeFunc) {
      props.usePromoCode(data);
    } else {
      if (buyGift) {
        props.buyGift(data);
      } else {
        props.calculatePrice(data, transition);
      }
    }
  };

  const purchaseAction = extractFromLinkState(
    PURCHASE_USED_KEY.PURCHASE_ACTION
  );
  const goToChoosePlanStep = () => {
    history.goBack();
  };
  const showPlanOwnerBox = () => {
    const ownerId = findOwnerId();
    return parseInt(user.id) !== parseInt(ownerId);
  };
  const formStep = extractFromLinkState(PURCHASE_USED_KEY.FORM_STEP);
  const planId = extractFromLinkState(PURCHASE_USED_KEY.PLAN_ID);
  const durationId = extractFromLinkState(PURCHASE_USED_KEY.DURATION_ID);

  return (
    <PurchaseContainer
      fullPageHeight={formStep === PURCHASE_STEPS_TYPE.CHOOSE_PLAN}
    >
      <Header title={PURCHASE_MODE_NAMES[purchaseAction]} />
      <Steps formStep={formStep} />
      <FormContainer>
        <ChoosePlan
          data={data}
          calculatePrice={data => calculatePrice(data, true, false)}
          buyGift={data => calculatePrice(data, false, true)}
          loading={calculatePriceLoading}
          mainLoading={loading}
          buyGiftLoading={buyGiftLoading}
          error={error}
          fetchNecessaryRequest={() => fetchNecessaryRequest()}
          formStep={formStep}
          purchaseAction={purchaseAction}
        />
        {formStep === PURCHASE_STEPS_TYPE.CONFIRM_PLAN && (
          <ConfirmPlan
            showPlanOwnerBox={showPlanOwnerBox()}
            walletAmount={getWalletAmount()}
            calculatePrice={(data, callWalletFunc, callPromoCodeFunc) =>
              calculatePrice(
                data,
                false,
                false,
                callWalletFunc,
                callPromoCodeFunc
              )
            }
            goToChoosePlanStep={goToChoosePlanStep}
            fetchNecessaryRequest={() => fetchNecessaryRequest()}
            userPlanData={{
              type: findAppropriateTypeForSend(),
              owner_id: findOwnerId(),
              plan_id: planId,
              duration_id: durationId
            }}
            mainLoading={loading}
          />
        )}
      </FormContainer>
    </PurchaseContainer>
  );
};

const mapStateToProps = store => {
  return {
    data: store.Premium.data,
    loading: store.Premium.initLoading,
    error: store.Premium.initError,
    user: store.User.data,
    calculatePriceLoading: store.Premium.calculatePriceLoading,
    buyGiftLoading: store.Premium.buyGiftLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getPremiumInit: data => {
      dispatch(PremiumAction.get(data));
    },
    calculatePrice: (data, transition) => {
      dispatch(PremiumAction.calculatePrice(data, transition));
    },
    buyGift: data => {
      dispatch(PremiumAction.buyGift(data));
    },
    useWallet: data => {
      dispatch(PremiumAction.useWallet(data));
    },
    usePromoCode: data => {
      dispatch(PremiumAction.usePromoCode(data));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Index));
